export default __webpack_public_path__ + "static/media/Muebles.6648c07c.png";